import { useState } from "react";
import Icon, {
    BranchesOutlined,
    CalendarFilled,
    CameraFilled,
    TableOutlined,
} from "@ant-design/icons";
import { Col, Menu, Drawer, Button, Space } from "antd";
import { Link } from "react-router-dom";
import "./index.scss";
const { SubMenu } = Menu;
const MenuContainer = ({ toggleMenu }) => {
    return (
        <Menu
            gutter={6}
            mode="inline"
            inlineCollapsed={toggleMenu}
            style={{
                minHeight: "1011px",
                borderRadius: 20,
                textAlign: "left",
            }}
        >
            {/* <Menu.Item
                key="dashboard"
                style={{
                    backgroundColor: "rgb(128 126 128 / 10%)",
                    marginTop: 30,
                    fontSize: "bold",
                }}
            >
                <Link
                    to="/dashboard"
                    style={{ fontWeight: "bold" }}
                >
                    <Icon
                        component={() => (
                            <img
                                src="/icon/doard.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    <span>Doardborad</span>
                </Link>
            </Menu.Item> */}
            <Menu.Item
                key="content"
                style={{
                    backgroundColor: "rgb(128 126 128 / 10%)",
                    fontSize: "bold",
                    marginTop: 30,
                }}
            >
                <Icon
                    component={() => (
                        <img
                            src="/icon/content.svg"
                            className="menu-img"
                        />
                    )}
                />
                <span style={{ fontWeight: "bold" }}>Content</span>
            </Menu.Item>
            <SubMenu
                key="home"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/home.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Home
                        </span>
                    </span>
                }
            >
                {/* <Menu.Item key="chudautu">
                    <Link to="/investor/edit/1">
                        <TableOutlined />
                        <span>Edit</span>
                    </Link>
                </Menu.Item> */}

                <Menu.Item key="home2">
                    <Link to="/block/list/">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/block.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>Block List</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="home1">
                    <Link to="/investor/banner">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/banner.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>Banner</span>
                    </Link>
                </Menu.Item>
            </SubMenu>
            <Menu.Item
                key="invester"
            >
                <Link
                    to="/investor/edit/1"
                >
                    <Icon
                        component={() => (
                            <img
                                src="/icon/invester.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    <span>Investor</span>
                </Link>
            </Menu.Item>
            <SubMenu
                key="Aboutaa"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/about.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            About
                        </span>
                    </span>
                }
            >
                <Menu.Item key="chudavutu">
                    <Link to="/about/edit/1">
                        <TableOutlined />
                        <span>Detail</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="chuddautu">
                    <Link to="/about/product/list">
                        <TableOutlined />
                        <span>Product</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="chudautau">
                    <Link to="/about/infrastructure/list">
                        <TableOutlined />
                        <span>Infrastructure</span>
                    </Link>
                </Menu.Item>
                {/* <Menu.Item key="chudautu">
                    <Link to="/investor/banner">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/banner.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>Banner</span>
                    </Link>
                </Menu.Item> */}
            </SubMenu>

            {/* <Menu.Item
                key="Abouta"
            >
                <Link
                    to="/about/edit/1"
                >
                    <Icon
                        component={() => (
                            <img
                                src="/icon/about.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    <span>About</span>
                </Link>
            </Menu.Item> */}
            <SubMenu
                key="why-chooseasda"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/why.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Why choose
                        </span>
                    </span>
                }
            >
                <Menu.Item key="adsaaaa">
                    <Link to="/why-choose/edit/1">
                        <TableOutlined />
                        <span>Detail</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="why-choose">
                    <Link to="/why-choose/inverstment/list">
                        <TableOutlined />
                        <span>Investment policy</span>
                    </Link>
                </Menu.Item>
            </SubMenu>
            <SubMenu
                key="quangtri-main"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/location.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Location
                        </span>
                    </span>
                }
            >
                <Menu.Item key="quangtri-main-a">
                    <Link to="/quang-tri/edit/1">
                        <TableOutlined />
                        <span>Detail</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="quangtri-main-b">
                    <Link to="/quang-tri/materials/list">
                        <TableOutlined />
                        <span>Materials</span>
                    </Link>
                </Menu.Item>
            </SubMenu>
            {/* <Menu.Item
                key="Aboutaaa"
            >
                <Link
                    to="/why-choose/edit/1"
                >
                    <Icon
                        component={() => (
                            <img
                                src="/icon/why.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    <span>Why choose</span>
                </Link>
            </Menu.Item> */}
            <SubMenu
                key="address"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/contact.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Contacts
                        </span>
                    </span>
                }
            >
                <Menu.Item key="addressa">
                    <Link to="/location/add">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/add.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>Add</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="addressv">
                    <Link to="/location/list">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List</span>
                    </Link>
                </Menu.Item>
            </SubMenu>
            <SubMenu
                key="news"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/news.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>News</span>
                    </span>
                }
            >
                <Menu.Item key="scheduledMailListdas">
                    <Link to="/news/add">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/add.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>Add</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="scheduledMailListdassda">
                    <Link to="/news/list">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List</span>
                    </Link>
                </Menu.Item>
            </SubMenu>
            <Menu.Item
                key="contact"
            // style={{
            //     backgroundColor: "rgb(128 126 128 / 10%)",
            //     marginTop: 30,
            //     fontSize: "bold",
            // }}
            >
                <Link
                    to="/contact/list"
                >
                    {/* <DashboardOutlined style={{ fontWeight: "bold" }} /> */}
                    <Icon
                        component={() => (
                            <img
                                src="/icon/newsletter.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    {/* <img src="/icon/doard.svg" className='menu-img'/> */}
                    <span>Newsletter</span>
                </Link>
            </Menu.Item>
            {/* <SubMenu
                key="media"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/media.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>Media</span>
                    </span>
                }
            >
                <Menu.Item key="scheduledMailListaaa">
                    <Link to="/media/add">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/add.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>Add</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="scheduledMailListasd">
                    <Link to="/media/list">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List</span>
                    </Link>
                </Menu.Item>
            </SubMenu> */}
            <Menu.Item
                key="media"
            // style={{
            //     backgroundColor: "rgb(128 126 128 / 10%)",
            //     marginTop: 30,
            //     fontSize: "bold",
            // }}
            >
                <Link
                    to="/media/list"
                >
                    {/* <DashboardOutlined style={{ fontWeight: "bold" }} /> */}
                    <Icon
                        component={() => (
                            <img
                                src="/icon/media.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    {/* <img src="/icon/doard.svg" className='menu-img'/> */}
                    <span>Media</span>
                </Link>
            </Menu.Item>
            {/* <SubMenu
                        key="word"
                        title={
                            <span>
                                <CalendarFilled />
                                <span style={{ marginTop: 10 }}>Work</span>
                            </span>
                        }
                    >
                        <Menu.Item key="wordadd">
                            <Link to="/work/add">
                                <TableOutlined />
                                <span>Add</span>
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="wordlist">
                            <Link to="/work/list">
                                <TableOutlined />
                                <span>List</span>
                            </Link>
                        </Menu.Item>
                    </SubMenu> */}

            {/* <SubMenu
                key="contact"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/contact.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Contact
                        </span>
                    </span>
                }
            >
                <Menu.Item key="contactad">
                    <Link to="/contact/list">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List</span>
                    </Link>
                </Menu.Item>
            </SubMenu> */}

            {/* <SubMenu
                key="block"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/block.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Block
                        </span>
                    </span>
                }
            >
                <Menu.Item key="blocka">
                    <Link to="/block/add">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/add.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>Add</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="blockc">
                    <Link to="/block/list">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List</span>
                    </Link>
                </Menu.Item>
            </SubMenu> */}
            <SubMenu
                key="brand"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/partner.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>Partners</span>
                    </span>
                }
            >
                <Menu.Item key="branda">
                    <Link to="/brand/add">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/add.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>Add</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="brandb">
                    <Link to="/brand/list">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List</span>
                    </Link>
                </Menu.Item>
            </SubMenu>
            {/* <Menu.Item
                key="menua"
            >
                <Link
                    to="/menu"
                >
                    <Icon
                        component={() => (
                            <img
                                src="/icon/menu.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    <span>Menu</span>
                </Link>
            </Menu.Item> */}
            <Menu.Item
                key="translate"
            // style={{
            //     backgroundColor: "rgb(128 126 128 / 10%)",
            //     marginTop: 30,
            //     fontSize: "bold",
            // }}
            >
                <Link
                    to="/translate"
                >
                    {/* <DashboardOutlined style={{ fontWeight: "bold" }} /> */}
                    <Icon
                        component={() => (
                            <img
                                src="/icon/translate.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    {/* <img src="/icon/doard.svg" className='menu-img'/> */}
                    <span>Translate</span>
                </Link>
            </Menu.Item>
            {/* <SubMenu
                key="chudautu"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/invester.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Investor
                        </span>
                    </span>
                }
            >

                <Menu.Item key="chudautu">
                    <Link to="/investor/edit/1">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/block.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>Block List</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="chudautu">
                    <Link to="/investor/banner">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/banner.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>Banner</span>
                    </Link>
                </Menu.Item>
            </SubMenu> */}
            {/* <Menu.Item
                key="why"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/why.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <Link to="/why-choose/edit/1">
                            <span style={{ marginTop: 10 }}>
                                Why choose
                            </span>
                        </Link>
                    </span>
                }
            >

                    <Icon
                        component={() => (
                            <img
                                src="/icon/why.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    <Link to="/why-choose/edit/1">
                        <span style={{ marginTop: 10 }}>
                            Why choose
                        </span>
                    </Link>

            </Menu.Item> */}

            {/* <SubMenu
                key="about"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/about.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            About
                        </span>
                    </span>
                }
            >
                <Menu.Item key="about">
                    <Link to="/about/edit/1">
                        <TableOutlined />
                        <span>Edit</span>
                    </Link>
                </Menu.Item>
            </SubMenu> */}
            <Menu.Item
                key="WorkShop"
                style={{
                    backgroundColor: "rgb(128 126 128 / 10%)",
                    fontSize: "bold",
                }}
            >
                <Icon
                    component={() => (
                        <img
                            src="/icon/workshop.svg"
                            className="menu-img"
                        />
                    )}
                />
                <span style={{ fontWeight: "bold" }}>WorkShop</span>
            </Menu.Item>
            {/* <SubMenu
                key="user"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/use1.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>User</span>
                    </span>
                }
            >
                <Menu.Item key="userlist">
                    <Link to="/user/list">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List</span>
                    </Link>
                </Menu.Item>
            </SubMenu> */}
            {/* <SubMenu
                key="setting"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/setting.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Setting
                        </span>
                    </span>
                }
            >
                <Menu.Item key="settinga">
                    <Link to="/setting/detail">
                        <TableOutlined />
                        <span>Detail</span>
                    </Link>
                </Menu.Item>
            </SubMenu> */}
            <Menu.Item
                key="setting"
            // style={{
            //     backgroundColor: "rgb(128 126 128 / 10%)",
            //     marginTop: 30,
            //     fontSize: "bold",
            // }}
            >
                <Link
                    to="/setting/detail"
                >
                    {/* <DashboardOutlined style={{ fontWeight: "bold" }} /> */}
                    <Icon
                        component={() => (
                            <img
                                src="/icon/setting.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    {/* <img src="/icon/doard.svg" className='menu-img'/> */}
                    <span>Setting</span>
                </Link>
            </Menu.Item>

            <Menu.Item
                key="myAccount"
                style={{
                    backgroundColor: "rgb(128 126 128 / 10%)",
                    fontSize: "bold",
                }}
            >
                <Icon
                    component={() => (
                        <img
                            src="/icon/account.svg"
                            className="menu-img"
                        />
                    )}
                />
                <span style={{ fontWeight: "bold" }}>
                    My account
                </span>
            </Menu.Item>
            {/* <SubMenu
                key="myAccountaas"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/user2.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>User</span>
                    </span>
                }
            >
                <Menu.Item key="myAccountav">
                    <Link to="/user/list">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List</span>
                    </Link>
                </Menu.Item>
            </SubMenu> */}
            <Menu.Item
                key="translatdsdfse"
            // style={{
            //     backgroundColor: "rgb(128 126 128 / 10%)",
            //     marginTop: 30,
            //     fontSize: "bold",
            // }}
            >
                <Link
                    // :to="{`/profile/edit/${localStorage.getItem('id')}`}"
                    to={`/profile/edit/${localStorage.getItem('id')}`}
                >
                    {/* <DashboardOutlined style={{ fontWeight: "bold" }} /> */}
                    <Icon
                        component={() => (
                            <img
                                src="/icon/user2.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    {/* <img src="/icon/doard.svg" className='menu-img'/> */}
                    <span>Profile</span>
                </Link>
            </Menu.Item>
            {/* <SubMenu
                key="Apikey"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/api.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Api key
                        </span>
                    </span>
                }
            >
                <Menu.Item key="Apikey1">
                    <Link to="/#">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/add.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>Add</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="Apikey2">
                    <Link to="/#">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List</span>
                    </Link>
                </Menu.Item>
            </SubMenu> */}
        </Menu>
    );
};

export default MenuContainer;
